// Constant for Admin Internal Request Item

/** Item Statuses */
export const STATUS = {
  PENDING              : 'pending',
  REJECTED             : 'rejected',
  PICKED               : 'picked',
  BORROWED             : 'borrowed',
  MARKED_FOR_RETURN    : 'marked_for_return',
  PARTIALLY_RETURNED   : 'partially_returned',
  RETURNED             : 'returned',
  PERMANENTLY_BORROWED : 'permanently_borrowed',
  COMPLETED            : 'completed',
  CANCELLED            : 'cancelled'
}

/** Item Reject Reasons */
export const REJECT_REASON = {
  QUANTITY_NOT_ENOUGH : 'qty_not_enough',
  MISSING             : 'missing',
  ERROR               : 'error'
}